import { render, staticRenderFns } from "./DsarPerStatus.vue?vue&type=template&id=223b7362&scoped=true&"
import script from "./DsarPerStatus.vue?vue&type=script&lang=js&"
export * from "./DsarPerStatus.vue?vue&type=script&lang=js&"
import style0 from "./DsarPerStatus.vue?vue&type=style&index=0&id=223b7362&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223b7362",
  null
  
)

export default component.exports